import { getDispatcher } from '@/utils/analysisTools/';
import WFSBean from '@/utils/analysisTools/beans/WFSBean';
import VectorMapLayer from '../components/VectorMapLayer';
export default {
    checkParameter(planInfo) {
        try {
            const param = {};
            let options = {};
            options.zoomRange = planInfo.configcont.basic.zoomRange;
            const thematic = planInfo.configcont.thematic;
            options = Object.assign(options, thematic.wfsConfig);
            thematic.radius ? options.size = thematic.radius:"";
            param.url = thematic.serviceUrl;
            param.layerName = thematic.serviceLayer;
            param.options = options;
            return param;
        } catch {
            return false;
        }
    },
    initLayer(vm, planInfo) {
        const params = this.checkParameter(planInfo);
        if (params) {
            const { url, layerName, options } = params;
            const bean = new WFSBean({ url, layerName });
            return new Promise((resolve, reject) => {
                getDispatcher(vm)
                    .read(bean)
                    .then(result => {
                        const vectorLayer = new VectorMapLayer(
                            'custom',
                            options
                        );
                        vectorLayer.setMap(vm.MapView.map);
                        vectorLayer.setData(result.geojson);
                        resolve(vectorLayer);
                    })
                    .catch(() => {
                        reject();
                    });
            });
        }
    },
};
